<span mat-dialog-title class="title">Custom Homesick Days Per Category</span>
<mat-dialog-content class="form-container">
  <div class="form" *ngIf="data.categories$ | async as categories">
    <div class="categories form-field">
      <span>Asset Categories</span>
      <mat-form-field appearance="outline" class="kh-dense-input kh-no-padding">
        <mat-select [(ngModel)]="selectedCategory">
          <mat-optgroup *ngFor="let group of categoriesSortedByGroup">
            {{ group.group }}
            <mat-option
              class="option kh-invert-checkbox"
              *ngFor="let category of group.categories"
              [value]="category"
            >
              {{ category.name }}
            </mat-option>
          </mat-optgroup>

          <mat-option *ngFor="let category of categories" [value]="category">{{
            category.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="default-days form-field">
      <span>Homesick Days</span>
      <mat-form-field appearance="outline" class="kh-dense-input kh-no-padding">
        <input type="number" matInput [(ngModel)]="defaultDays" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <button mat-flat-button mat-dialog-close>CANCEL</button>
  <button mat-flat-button color="primary" (click)="addCategory()">
    SAVE CHANGES
  </button>
</mat-dialog-actions>
